import React from 'react';
import { CommanPaymentMethod } from '../../../common'

export const PaymentMethod: React.FC = () => {
    return (
        <CommanPaymentMethod />
    );
};
